enum MeasuresCategory {
  INCENTIVES = 'INCENTIVES',
  MOTIVATION = 'MOTIVATION',
  CULTURE = 'CULTURE',
  INFRASTRUCTURE = 'INFRASTRUCTURE',
}

export default MeasuresCategory;
